let baseURL = "";
let loginBaseUrl = "";
let saleFishUrl = "";

if (process.env.VUE_APP_MODE === "development") {
  // Development mode
  baseURL = process.env.VUE_APP_BASE_URL;
  loginBaseUrl = process.env.VUE_APP_BASE_URL_LOGIN;
  saleFishUrl = process.env.VUE_APP_BASE_URL_SALE_FISH
} else {
  // Production mode
  const currentUrl = window.location.href;
  if (currentUrl.startsWith("https://develop")) {
    // If the app is being served from a URL that starts with "develop"
    baseURL = process.env.VUE_APP_BASE_URL_DEV;
    loginBaseUrl = process.env.VUE_APP_BASE_URL_LOGIN_DEV;
    saleFishUrl = process.env.VUE_APP_BASE_URL_SALE_FISH_PRO
  } else {
    // Otherwise use the production URL
    baseURL = process.env.VUE_APP_BASE_URL_PRO;
    loginBaseUrl = process.env.VUE_APP_BASE_URL_LOGIN_PRO;
    saleFishUrl = process.env.VUE_APP_BASE_URL_SALE_FISH_PRO
  }
}

export { baseURL, loginBaseUrl, saleFishUrl };
